import React from 'react';
import PropTypes from 'prop-types';

import TestBackend from '../../../DragDropContextProvider/TestBackend';
import DragDropContextProvider from '../../../DragDropContextProvider';

// Apply TestBackend for drag and drop on test environment
const isTestEnv = process.env.NODE_ENV === 'test';

class DraggableManager extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    dataHook: PropTypes.string,
  };

  render() {
    const { dataHook, children } = this.props;

    return (
      <div data-hook={dataHook}>
        <DragDropContextProvider backend={isTestEnv ? TestBackend : undefined}>
          {children}
        </DragDropContextProvider>
      </div>
    );
  }
}

export default DraggableManager;
